import { BFFAgent } from 'BFFAgent'
import {
  COMMON_CAN_DELETE_BEGIN,
  COMMON_CAN_DELETE_SUCCESS,
  COMMON_CAN_DELETE_FAILURE,
  COMMON_RESET_CAN_DELETE,
} from '../constants'

export function getCanDelete(requestsId, type) {
  return async (dispatch) => {
    dispatch({
      type: COMMON_CAN_DELETE_BEGIN
    })
    try {
      const checkRequestsId = (requests)=>{
        const arrayRequests = requests.split(",")
        if(requests==='undefined' || requests===null || requests===''){
          return false
        }else if(arrayRequests.lenght!==1){
          let check = arrayRequests.some(r=>r==='undefined')
          return !check
        }
        return true
      }
      let result
      if (type == 'initial') {
        result = {can: null, message: ""}
      } else {
        result = checkRequestsId(requestsId) ? await BFFAgent.Stock.TakingCarManagement.getCanDelete(requestsId) : {can: true, message: ""}
      }
      dispatch({
        type: COMMON_CAN_DELETE_SUCCESS,
        data: { data: result, type }
      })
    } catch (err) {
      dispatch({
        type: COMMON_CAN_DELETE_FAILURE,
        data: err?.message
      })
    }
  }
}

export function resetCanDeleted() {
  return (dispatch) => {
    dispatch({
      type: COMMON_RESET_CAN_DELETE
    })
  }
}
